function submitLoanData() {
  $('#submit-ajax-form-btn').click(function () {
    disableSubmit()

    let errorString = [];

    const dateReceived = $('#add-loan-form input[name="loan[date_received]"]').val()
    const principal = $('#add-loan-form input[name="loan[principal]"]').val()
    const interest =$('#add-loan-form input[name="loan[interest]"]').val()
    const servicingDuration = $('#add-loan-form input[name="loan[servicing_duration]"]').val()
    const loanSource = $('#add-loan-form input[name="loan[loan_source]"]').val()
    const details = $('#add-loan-form input[name="loan[details]"]').val()

    if (isEmpty(dateReceived) || isEmpty(principal) ||
      isEmpty(interest) || isEmpty(servicingDuration)) {
      errorString.push(' Date, principal, interest and duration required!');
    }

    const paymentOptions = getPaymentOptionsStorage()

    if (paymentOptions === null ||
      paymentOptions === undefined ||
      (Array.isArray(paymentOptions) && paymentOptions.length === 0)) {
      errorString.push('Payment option amount not set')
    }

    if (errorString.length > 0) {
      toastNotification('error', errorString.join(','))
    } else {
      $('#spinner-modal').modal('show');

      const postUrl = $('#add-loan-form').attr('action')
      const paymentOptions = getPaymentOptionsStorage()


      let action = "post"

      if ($('#add-loan-form input[name="loan[loan_action]"').val() === 'update') {
        action = "patch"
      }

      $.ajax({
        type: action,
        url: postUrl,
        headers: {
          'X-CSRF-Token': csrfToken()
        },
        data: {
          payment_options: paymentOptions,
          loan: {
            date_received: dateReceived,
            principal: removeCommas(principal),
            interest: interest,
            servicing_duration: servicingDuration,
            loan_source: loanSource,
            details: details
          }
        },
        dataType: "json",
        success: function (data) {
          removePaymentOptionData()
          window.location.replace(data.redirect_url)
          console.log(data)
        },
        error: function (data) {
          disableSubmit()
          console.log('An error occurred.');
          console.log(data);
        },
      });
    }
  });
}

$(document).ready(function () {
  if ($('#add-loan-form').length > 0) {

    if ($('.principal-amount-div').length > 0) {
      checkAmount('.principal-amount', '.principal-amount-div');
    }

    submitLoanData()
    clearFailedSubmit('#add-loan-form')
  }
});
